import axiosClient from './axiosClient';
import createFormData from './formData';

const SELECTED_MENU_STORAGE_KEY = 'selected_menu_id';
const SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY =
  'selected_menu_establishment_id';

const getSelectedMenuId = (establishmentId = null) => {
  const menuId = localStorage.getItem(
    SELECTED_MENU_STORAGE_KEY,
  );

  const menuEstablishmentId = localStorage.getItem(
    SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY,
  );

  if (
    establishmentId &&
    menuEstablishmentId &&
    String(menuEstablishmentId) !== String(establishmentId)
  ) {
    return '';
  }

  return menuId || '';
};

const selectMenu = (menuId, establishmentId = null) => {
  if (!menuId) {
    localStorage.removeItem(SELECTED_MENU_STORAGE_KEY);
    localStorage.removeItem(
      SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY,
    );

    return;
  }

  localStorage.setItem(
    SELECTED_MENU_STORAGE_KEY,
    String(menuId),
  );

  if (establishmentId) {
    localStorage.setItem(
      SELECTED_MENU_ESTABLISHMENT_STORAGE_KEY,
      String(establishmentId),
    );
  }
};

const normalizeMenuPayload = (payload = {}) => ({
  ...payload,
  category_ids: Array.isArray(payload.category_ids)
    ? payload.category_ids
    : [],
  product_ids: Array.isArray(payload.product_ids)
    ? payload.product_ids
    : [],
  is_active: payload.is_active ? 1 : 0,
  is_default: payload.is_default ? 1 : 0,
  sort_order: payload.sort_order || 0,
});

export const menusApi = {
  getMenus(establishmentId, params = {}) {
    return axiosClient.get(
      `/establishments/${establishmentId}/menus`,
      {
        params,
      },
    );
  },

  getMenu(menuId) {
    return axiosClient.get(`/menus/${menuId}`);
  },

  createMenu(establishmentId, payload = {}) {
    const formData = createFormData(
      normalizeMenuPayload(payload),
    );

    return axiosClient.post(
      `/establishments/${establishmentId}/menus`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  updateMenu(menuId, payload = {}) {
    const formData = createFormData({
      ...normalizeMenuPayload(payload),
      _method: 'PUT',
    });

    return axiosClient.post(`/menus/${menuId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateStatus(menuId, isActive) {
    return axiosClient.patch(`/menus/${menuId}/status`, {
      is_active: isActive ? 1 : 0,
    });
  },

  updateOrdering(menuId, orderingEnabled) {
    return axiosClient.patch(`/menus/${menuId}/ordering`, {
      ordering_enabled: orderingEnabled ? 1 : 0,
    });
  },

  setDefault(menuId) {
    return axiosClient.patch(`/menus/${menuId}/default`);
  },

  reorderMenus(establishmentId, menus) {
    return axiosClient.patch(
      `/establishments/${establishmentId}/menus/reorder`,
      {
        menus,
      },
    );
  },

  deleteMenu(menuId) {
    return axiosClient.delete(`/menus/${menuId}`);
  },

  selectMenu,

  getSelectedMenuId,
};

export default menusApi;